







































































import {Component} from '@/shared/component';
import {Approvisionnement} from '@/models';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';

import storeApprovisionnement from '@/stores/modules/approvisionnement';

import CrudFournisseurShow from '@/components/Crud/Fournisseur/Show.vue';
import CrudFournisseurEdit from '@/components/Crud/Fournisseur/Edit.vue';

@Component({
	components: {
		CrudFournisseurShow,
		CrudFournisseurEdit,
	}
})
export default class CrudApprovisionnementShow extends AbstractShowVue<Approvisionnement> {
	public constructor() {
		super(storeApprovisionnement);
	}
}
